import { TextInput, TextInputProps } from "@oysterhr/ui"

import { convertToMaxDecimals } from "@oysterhr/common"
import { forwardRef } from "react"

type NumericTextInputProps = {
  maxDecimalsDigits?: number
} & TextInputProps

/*
 ** A variation of the Text Input specialized in number input handling
 ** You can use the `maxDecimalsDigits` prop to specify the number of decimals digits
 ** that the input should accept. It defaults to 0.
 */
export const NumericTextInput = forwardRef<HTMLInputElement, NumericTextInputProps>(
  ({ onChange, name, maxDecimalsDigits = 0, ...props }, ref) => {
    return (
      <TextInput
        key={name}
        name={name}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          e.target.value = convertToMaxDecimals(e.target.value, maxDecimalsDigits)
          if (onChange) {
            onChange(e)
          }
        }}
        ref={ref}
        {...props}
      />
    )
  },
)
